import type { FC } from "react";

import Carousel from "@/design-system/carousel";
import { useViewportInfoContext } from "@/src/contexts";
import * as stylex from "@stylexjs/stylex";

import ArticleBox, { type IArticleBox } from "./ArticleBox";

const styles = stylex.create({
    container: { marginBlock: "0", marginInline: "-10px", marginTop: "40px" },
    carousel: { scrollSnapType: "x mandatory" },
});

export interface IArticleBoxList {
    data: IArticleBox[];
}

export const ArticleBoxList: FC<IArticleBoxList> = ({ data }) => {
    const { isMobile } = useViewportInfoContext();
    return (
        data && (
            <div {...stylex.props(styles.container)}>
                <Carousel
                    showArrows={!isMobile}
                    centerMode={isMobile}
                    styleX={styles.carousel}
                    itemsToShow={isMobile ? 1.1 : 3}
                >
                    {data.map((value, index) => (
                        <ArticleBox {...value} key={index} />
                    ))}
                </Carousel>
            </div>
        )
    );
};
